var _linearGradient, _linearGradient2, _linearGradient3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "250mm",
    height: "250mm",
    viewBox: "0 0 250 250",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient883"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#77b7db",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop879"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#3271d2",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1080"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2166d0",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop1076"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#7cbddd",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop1078"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    href: "#linearGradient1080",
    id: "linearGradient853",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.45,0,0,0.45,63.070868,7.6463908)",
    x1: 139.67674,
    y1: 532.11578,
    x2: 139.52257,
    y2: 468.35855
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    href: "#linearGradient1080",
    id: "linearGradient861",
    x1: -332.28299,
    y1: 491.00034,
    x2: -331.94458,
    y2: -51.699722,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.44755117,0,0,0.44965685,274.18253,26.004352)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    href: "#linearGradient883",
    id: "linearGradient875",
    x1: -330.16321,
    y1: 491.16156,
    x2: -331.71402,
    y2: -51.285236,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.45,0,0,0.45,274.89165,25.835575)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path850",
    style: {
      fill: "url(#linearGradient875)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.119062
    },
    d: "M 125.62034,2.7572178 27.047298,247.16577 53.9031,234.37958 105.42577,106.79109 h 0.11906 l -0.0821,103.22718 20.05459,-9.21083 v 0 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path848",
    style: {
      fill: "url(#linearGradient861)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.118693
    },
    d: "m 125.62034,2.7572178 -0.10301,198.0502222 97.43537,46.35833 -34.17302,-86.25448 -17.93288,9.30466 14.41004,36.49944 -39.86523,-19.17954 0.1531,-80.51874 h 0.11842 l 18.02908,45.56615 18.01683,-9.16081 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "hue",
      fill: "url(#linearGradient853)",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 74.221158,247.24278 51.634862,-28.83506 51.1878,28.7233 z",
    id: "path847"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fa0e4a3f4587087d31ee5d7f43807c01.svg";
export { ForwardRef as ReactComponent };